import PropTypes from 'prop-types';
import styles from './colorSelection.module.scss';

const ColorSelection = ({ setIsPickerVisible, pickedColor }) => {
  return (
    <div className={styles['picked-color-container']}>
      <div className={styles['picked-color-text']}>Color*</div>
      <div className={styles['picked-color-parent-div']}>
        <button
          onClick={() => setIsPickerVisible(true)}
          style={{ backgroundColor: pickedColor || 'white' }}
          className={styles['color-selection-button']}>
          <span
            className={styles['display-picked-color-span-1']}
          />
        </button>
        <span className={styles['display-picked-color-span-2']}>-</span>
        <span className={styles['display-picked-color-span-3']}>
          <input
            value={pickedColor}
            className={styles['picked-color-input']}
            placeholder="#ffffff"
          />
        </span>
      </div>
    </div>
  );
};

export default ColorSelection;

ColorSelection.propTypes = {
  setIsPickerVisible: PropTypes.node.isRequired,
  pickedColor: PropTypes.string.isRequired,
};
